
import React from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Hidden from '@material-ui/core/Hidden';

const useStyles = makeStyles((theme) => ({
    mobileSelectControl: {
        width: 'clamp(128px, 36vw, 188px)',
        minWidth: 0,
        '& .MuiOutlinedInput-root': {
            height: 34,
            minHeight: 34,
            borderRadius: 18,
            background: '#ffffff',
            color: '#002D55',
            fontWeight: 600,
            fontSize: 'clamp(0.72rem, 0.78vw, 0.9rem)',
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(0, 45, 85, 0.12)',
            borderRadius: 18,
        },
        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(0, 45, 85, 0.12)',
        },
        '& .MuiSelect-outlined': {
            paddingTop: 4,
            paddingBottom: 4,
            paddingLeft: 10,
            paddingRight: 28,
            textAlign: 'center',
            textAlignLast: 'center',
        },
        '& .MuiSelect-icon': {
            color: '#002D55',
            right: 8,
        },
        [theme.breakpoints.down('xs')]: {
            '& .MuiOutlinedInput-root': {
                height: 28,
                minHeight: 28,
            },
            '& .MuiSelect-outlined': {
                paddingTop: 3,
                paddingBottom: 3,
                paddingLeft: 8,
                paddingRight: 24,
            },
        },
    },
}));

const CustomTabs = withStyles({
    root: {
        minHeight: 48,
    },
    indicator: {
        backgroundColor: '#fb741a',
        height: 3,
        borderRadius: 999,
    },
})(Tabs);

const CustomTab = withStyles((theme) => ({
    root: {
        textTransform: 'none',
        fontWeight: 500,
        fontSize: 14,
        minHeight: 48,
        minWidth: 54,
        padding: '0 16px',
        color: '#324158',
        transition: 'color 0.18s ease',
        [theme.breakpoints.down('md')]: {
            minWidth: 56,
            padding: '0 12px',
            fontSize: 12,
        },
        '&$selected': {
            color: '#002D55',
            fontWeight: 700,
        },
    },
    selected: {},
}))((props) => <Tab disableRipple {...props} />);

export default function LandingTabs({ tabs = [], value, onChange }) {
    const classes = useStyles();
    const visibleTabs = tabs.filter((tab) => tab.visible);
    const safeValue = visibleTabs.some((tab) => tab.value === value)
        ? value
        : (visibleTabs[0]?.value || false);

    return (
        <>
            <Hidden mdUp>
                <FormControl variant="outlined" size="small" className={classes.mobileSelectControl}>
                <Select
                    value={safeValue || ''}
                    onChange={(event) => onChange(event, event.target.value)}
                    MenuProps={{
                        getContentAnchorEl: null,
                        anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'left',
                        },
                        transformOrigin: {
                            vertical: 'top',
                            horizontal: 'left',
                        },
                        PaperProps: {
                            style: { borderRadius: 18, marginTop: 8, overflow: 'hidden' },
                        },
                    }}
                >
                    {visibleTabs.map((tab) => (
                        <MenuItem key={tab.value} value={tab.value}>{tab.label}</MenuItem>
                    ))}
                </Select>
                </FormControl>
            </Hidden>
            <Hidden smDown>
                <CustomTabs
                    value={safeValue}
                    onChange={onChange}
                    centered
                    textColor="primary"
                    style={{ width: '100%', maxWidth: 760 }}
                >
                    {visibleTabs.map((tab) => (
                        <CustomTab key={tab.value} value={tab.value} label={tab.label} />
                    ))}
                </CustomTabs>
            </Hidden>
        </>
    );
}